// extracted by mini-css-extract-plugin
export default {"ButtonLittle":"ButtonLittle_ButtonLittle__AWCQe"};